import React from 'react';

export default function Spinner() {
  return (
    <div className="d-flex  justify-content-center text-center loaderScreen">
      <div class="spinner-border text-success my-auto" role="status">
        <span class="sr-only">Loading...</span>
      </div>
    </div>
  );
}
